import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { ViewerGuardedButton } from '@/components/shared/ViewerGuardedButton';

export interface CancelOrderConfirmationDialogProps {
  open: boolean;
  orderIdentifier: string;
  cancellationReason: string;
  onCancellationReasonChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export const CancelOrderConfirmationDialog = ({
  open,
  orderIdentifier,
  cancellationReason,
  onCancellationReasonChange,
  onCancel,
  onConfirm,
  isSubmitting,
}: CancelOrderConfirmationDialogProps) => {
  const hasCancellationReason = cancellationReason.trim().length > 0;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      aria-labelledby="cancel-order-confirmation-title"
      aria-describedby="cancel-order-confirmation-description"
    >
      <DialogTitle
        id="cancel-order-confirmation-title"
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <WarningIcon color="error" />
        Cancel Order
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="cancel-order-confirmation-description">
          Are you sure you want to cancel order <strong>{orderIdentifier}</strong>? This action
          cannot be undone.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="Cancellation Reason"
          fullWidth
          multiline
          minRows={3}
          value={cancellationReason}
          onChange={(event) => onCancellationReasonChange(event.target.value)}
          placeholder="Enter the reason for cancelling this order"
          slotProps={{ htmlInput: { maxLength: 500 } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit" disabled={isSubmitting}>
          No, Keep Order
        </Button>
        <ViewerGuardedButton
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isSubmitting || !hasCancellationReason}
        >
          {isSubmitting ? 'Cancelling...' : 'Yes, Cancel Order'}
        </ViewerGuardedButton>
      </DialogActions>
    </Dialog>
  );
};
